import { Search, X } from "lucide-react";

/**
 * StorefrontFilters — search input + horizontally scrollable category pills.
 * Categories are derived from the products themselves (unique
 * `product.category` values) plus a leading "All" pill. Mobile: pills
 * scroll horizontally with no scrollbar visible; desktop uses the same
 * pills so navigation stays predictable.
 */
export function StorefrontFilters({
  primaryLabel = "Products",
  query,
  onQueryChange,
  categories = [],
  activeCategory = "All",
  onCategoryChange,
}) {
  return (
    <div className="mb-5 space-y-3" data-testid="storefront-filters">
      <div className="relative">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
        <input
          type="search"
          value={query || ""}
          onChange={(e) => onQueryChange(e.target.value)}
          placeholder={`Search ${primaryLabel.toLowerCase()}…`}
          className="w-full h-11 rounded-full border border-gray-200 bg-white pl-10 pr-10 text-sm font-body focus:outline-none focus:ring-2 focus:ring-tbc-gold/40 focus:border-tbc-gold"
          data-testid="storefront-search"
          aria-label={`Search ${primaryLabel}`}
        />
        {query ? (
          <button
            type="button"
            onClick={() => onQueryChange("")}
            aria-label="Clear search"
            className="absolute right-2 top-1/2 -translate-y-1/2 p-1 rounded-full text-gray-400 hover:text-tbc-navy"
          >
            <X className="w-4 h-4" />
          </button>
        ) : null}
      </div>

      {categories.length > 1 && (
        <div className="flex gap-2 overflow-x-auto no-scrollbar pb-1 -mx-1 px-1" role="tablist">
          {categories.map((cat) => {
            const isActive = cat === activeCategory;
            return (
              <button
                key={cat}
                type="button"
                role="tab"
                aria-selected={isActive}
                onClick={() => onCategoryChange(cat)}
                data-testid={`storefront-cat-${cat}`}
                className={
                  "whitespace-nowrap px-3.5 py-1.5 rounded-full text-xs font-medium transition-colors " +
                  (isActive
                    ? "bg-tbc-navy text-white"
                    : "bg-tbc-cream text-tbc-navy hover:bg-tbc-gold/20")
                }
              >
                {cat}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default StorefrontFilters;
